import { useSnackbar } from 'notistack';
import useAuth from './useAuth';

export default function usePermissions() {
  const { user } = useAuth();
  const { enqueueSnackbar } = useSnackbar();

  const hasPermission = (permissionId) => {
    if (!user) return false;
    
    // Admin override: If the user's role ID is 1 (Admin) or 2 (Super Admin), they get everything.
    if (user.roleId === 1 || user.roleId === 2) return true;

    if (!user.permissions || !Array.isArray(user.permissions)) return false;
    return user.permissions.includes(parseInt(permissionId, 10));
  };

  const checkPermission = (permissionId, actionName = 'this action') => {
    const permitted = hasPermission(permissionId);
    if (!permitted) {
      enqueueSnackbar(`Access Denied: You do not have permission to perform ${actionName}.`, {
        variant: 'error'
      });
    }
    return permitted;
  };

  return { hasPermission, checkPermission };
}
